// frontend/src/components/common/RiskLegendTooltip.jsx
// The risk level column header's hover card: every level's chip beside what it
// means, in the order rows sort (riskLevels.js).

import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import RiskChip from './RiskChip';
import { RISK_LEVELS } from './riskLevels';
import '../grid/TooltipCard.css';
import './RiskLegendTooltip.css';

export default function RiskLegendTooltip() {
  const { t } = useTranslation();
  return (
    <div className="tooltip-card risk-legend-tooltip">
      {RISK_LEVELS.map((level) => (
        <Fragment key={level}>
          <RiskChip value={level} />
          <span>{t(`reports.stockout.riskLegend.${level}`)}</span>
        </Fragment>
      ))}
    </div>
  );
}
